<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Vehicle Deliveries Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Vehicle Deliveries Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Vehicle Deliveries Report",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      // Value from user input for adding category
      data: {
        description: "",
        vehicle: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        filterdata: {}
      },
      // edit category
      editdata: {
        description: "",
        vehicle: "",
        id: "",
        date: "",
        filterdata: {}
      },
      // make inputs required
      dateError: "",
      vehicleError: "",
      // delete category
      deletedata: {
        vehicle: "",
        date: "",
        id: "",
        filterdata: {}
      },
      filterdata: {
        vehicles: "",
        fromdate: moment(new Date()).format("YYYY-MM-DD"),
        todate: moment(new Date()).format("YYYY-MM-DD"),
        branch_id: 0
      }
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("vehicles", ["VehicleDeliveries", "SaveStatus", "Vehicles","FilterStatus"]),
    ...mapGetters("auth", ["MyUserPerm","branchid","Branches"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "delivery_vehicle",
          sortable: true,
          label: "VEHICLE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "user.name",
          sortable: true,
          label: "RECORDED BY",
        },
        {
          key: "created_at",
          sortable: true,
          label: "RECORDED ON",
        },
      ];

      if (this.branchid==0) {
        baseFields.splice(6, 0,
          {
            key: "branch.name",
            sortable: true,
            label: "BRANCH",
          }       
        );
      }
      return baseFields;
    },
    /**
     * Total no. of records
     */

    rows() {
      return this.VehicleDeliveries ? this.VehicleDeliveries.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.VehicleDeliveries ? this.VehicleDeliveries.length : 1;
  },
  updated() { },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchVehicleDeliveries: "vehicles/fetchDeliveries",
      AddDelivery: "vehicles/recordDelivery",
      EditDelivery: "vehicles/editDelivery",
      DeleteDelivery: "vehicles/deleteDelivery",
      FetchVehicles: "vehicles/fetchVehicles",
    }),
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addDelivery(modalId) {
      this.modal_id = modalId;
      if (this.data.vehicle === "") {
        this.vehicleError = "Vehicle is required";
        return;
      } else {
        this.vehicleError = "";
      }
      if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }
      this.data.filterdata = this.filterdata;
      this.AddDelivery(this.data);
    },

    resetAddDelivery() {
      this.data.date = "";
      this.data.description = "";
      this.data.vehicle = "";
      this.dateError = "";
      this.vehicleError = "";
      this.modal_id = "";
    },
    resetEditDelivery() {
      this.editdata.date = "";
      this.editdata.description = "";
      this.editdata.vehicle = "";
      this.editdata.id = "";
      this.modal_id = "";
    },

    resetDeleteExp() {
      this.deletedata.vehicle = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.dateError = "";
      this.vehicleError = "";
    },
    showEditModal(data) {
      this.editdata.date = data.item.date;
      this.editdata.id = data.item.id;
      this.editdata.vehicle = data.item.vehicle.name;
      this.editdata.description = data.item.description;
    },
    editDelivery(modalId) {
      this.modal_id = modalId;
      this.editdata.filterdata = this.filterdata;
      this.EditDelivery(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.vehicle = data.item.vehicle.name;
      this.deletedata.date = data.item.date;
      this.deletedata.id = data.item.id;
    },
    deleteVehicleDelivery(modalId) {
      this.modal_id = modalId;
      this.deletedata.filterdata = this.filterdata;
      this.DeleteDelivery(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    filterDeliveries(){
      this.FetchVehicleDeliveries(this.filterdata);
    }

  },
  created() {
    this.FetchVehicleDeliveries(this.filterdata);
    this.FetchVehicles();
  },
};
</script>

<template>
  <Layout>
    <Toasts :show-progress="true" :rtl="true" :max-messages="20" :time-out="3000" :closeable="false" :solid="true">
    </Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select :list="Branches ? [{ id: 0, name: 'All Branches' }, ...Branches] : []" v-model="filterdata.branch_id" option-value="id"
                  option-text="name" placeholder="Select Branch" @input="filterDeliveries">
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>From</label>
                  <input type="date" v-model="filterdata.fromdate" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>To</label>
                  <input type="date" v-model="filterdata.todate" class="form-control" />
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label>VEHICLES</label>
                <model-list-select :list="Vehicles ? Vehicles : []" v-model="filterdata.vehicle" option-value="id"
                  option-text="plate_number" placeholder="Select Vehicle" @input="filterDeliveries">
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterDeliveries">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner v-show="FilterStatus" variant="light" small role="status"></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                      :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" :items="VehicleDeliveries ? VehicleDeliveries : []" :fields="fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(delivery_vehicle)="data">
                  {{ data.item.vehicle.make }}-{{ data.item.vehicle.model }}{{ data.item.vehicle.plate_number }}
                </template>
                <template #cell(created_at)="data">
                  {{ new Date(data.item.created_at).toLocaleString('en-GB', { hour12: true }).replace(',', ':') }}
                </template>
              </b-table>
            </div>
            <Loader v-if="!VehicleDeliveries" />
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
